/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * List of long integers.
 * @export
 * @interface PredicateLongValues
 */
export interface PredicateLongValues {
  /**
   *
   * @type {Array<string>}
   * @memberof PredicateLongValues
   */
  values?: Array<string>;
}

/**
 * Check if a given object implements the PredicateLongValues interface.
 */
export function instanceOfPredicateLongValues(value: object): value is PredicateLongValues {
  return true;
}

export function PredicateLongValuesFromJSON(json: any): PredicateLongValues {
  return PredicateLongValuesFromJSONTyped(json, false);
}

export function PredicateLongValuesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PredicateLongValues {
  if (json == null) {
    return json;
  }
  return {
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function PredicateLongValuesToJSON(json: any): PredicateLongValues {
  return PredicateLongValuesToJSONTyped(json, false);
}

export function PredicateLongValuesToJSONTyped(
  value?: PredicateLongValues | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    values: value['values'],
  };
}
